export const getMaxColumns = rows => {
  return Math.max(...rows.map(row => row.data.length));
};
